import http from './http';

export function login(data) {
    return http.post(`/auth/login`, data);
}

export function logout(data) {
    return http.post(`/auth/logout`, data);
}
